import {
  Link,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Text,
} from '@tonic-one/react';
import SmartTooltip from '../../Report/SmartTooltip';

export const ForensicDataContent = ({ logItem }: { logItem: any }) => {
  const { dlpForensicDataContent: content, scanSource } = logItem;
  if (!content || !scanSource) {
    return <></>;
  }
  if (scanSource === 'Exchange Server') {
    return (
      <SmartTooltip>
        {content.replace(/</g, '&lt;').replace(/>/g, '&gt;')}
      </SmartTooltip>
    );
  } else {
    const parsedContent = JSON.parse(content);
    if (Array.isArray(parsedContent) && parsedContent.length > 0) {
      //find the first item, which has ForensicData and ForensicData.ForensicDataContent
      let item: any = null;
      for (const v of parsedContent) {
        if (v.ForensicData && v.ForensicData.ForensicDataContent) {
          item = v;
          break;
        }
      }
      if (!item) {
        return <></>;
      }
      const { ForensicData: forensicData, Name: name } = item;
      const { commonStringArr, highlightStringArr } = getStringArr(
        forensicData?.ForensicDataContent || '',
        forensicData?.ForensicEntity?.EntityDetails || []
      );
      const highLightContent = (
        <HightLightContent {...{ commonStringArr, highlightStringArr }} />
      );
      return (
        <Popover placement="left" trigger="hover">
          <PopoverTrigger>
            <Link width="100%">
              <Text
                overflow="hidden"
                whiteSpace="nowrap"
                textOverflow="ellipsis"
              >
                {highLightContent}
              </Text>
            </Link>
          </PopoverTrigger>
          <PopoverContent
            maxWidth="600px"
            PopperProps={{
              usePortal: true,
            }}
            flexWrap="wrap"
            wordBreak="break-all"
          >
            <>
              <Text>{name}</Text>
              <Text>{highLightContent}</Text>
            </>
          </PopoverContent>
        </Popover>
      );
    } else {
      return <></>;
    }
  }
};

const HightLightContent = ({
  highlightStringArr,
  commonStringArr,
}: {
  commonStringArr: string[];
  highlightStringArr: string[];
}) => {
  return (
    <>
      {highlightStringArr.map((value, index) => {
        return (
          <span key={value}>
            {commonStringArr[index]}
            <span style={{ color: 'red' }}>{value}</span>
          </span>
        );
      })}
      {commonStringArr[commonStringArr.length - 1]}
    </>
  );
};

const getStringArr = (forensicDataContent: string, entityDetails: any) => {
  if (!Array.isArray(entityDetails) || entityDetails.length === 0) {
    return {
      commonStringArr: [forensicDataContent],
      highlightStringArr: [],
    };
  }
  const commonStringArr: string[] = [];
  const highlightStringArr: string[] = [];
  let startPosition = 0;
  try {
    const sortedDetails = entityDetails.sort(
      (a, b) => a.PositionOffset - b.PositionOffset
    );
    for (let i = 0; i < sortedDetails.length; i++) {
      commonStringArr.push(
        forensicDataContent.slice(
          startPosition,
          entityDetails[i].PositionOffset
        )
      );
      highlightStringArr.push(
        forensicDataContent.slice(
          sortedDetails[i].PositionOffset,
          sortedDetails[i].PositionOffset + sortedDetails[i].Length
        )
      );
      startPosition = sortedDetails[i].PositionOffset + sortedDetails[i].Length;
      if (i === sortedDetails.length - 1) {
        commonStringArr.push(forensicDataContent.slice(startPosition));
      }
    }
  } catch {
    return {
      commonStringArr: [forensicDataContent],
      highlightStringArr: [],
    };
  }

  return {
    commonStringArr,
    highlightStringArr,
  };
};
